// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options } from '@hey-api/client-fetch'
import type {
  CantonListData,
  CantonListError,
  CantonListResponse,
  CantonCreateData,
  CantonCreateError,
  CantonCreateResponse,
  CantonRetrieveData,
  CantonRetrieveError,
  CantonRetrieveResponse,
  CantonUpdateData,
  CantonUpdateError,
  CantonUpdateResponse,
  CantonPartialUpdateData,
  CantonPartialUpdateError,
  CantonPartialUpdateResponse,
  CantonDestroyData,
  CantonDestroyError,
  CantonDestroyResponse,
  CategoryListData,
  CategoryListError,
  CategoryListResponse,
  CategoryCreateData,
  CategoryCreateError,
  CategoryCreateResponse,
  CategoryRetrieveData,
  CategoryRetrieveError,
  CategoryRetrieveResponse,
  CategoryUpdateData,
  CategoryUpdateError,
  CategoryUpdateResponse,
  CategoryPartialUpdateData,
  CategoryPartialUpdateError,
  CategoryPartialUpdateResponse,
  CategoryDestroyData,
  CategoryDestroyError,
  CategoryDestroyResponse,
  EducationListData,
  EducationListError,
  EducationListResponse,
  EducationCreateData,
  EducationCreateError,
  EducationCreateResponse,
  EducationRetrieveData,
  EducationRetrieveError,
  EducationRetrieveResponse,
  EducationUpdateData,
  EducationUpdateError,
  EducationUpdateResponse,
  EducationPartialUpdateData,
  EducationPartialUpdateError,
  EducationPartialUpdateResponse,
  EducationDestroyData,
  EducationDestroyError,
  EducationDestroyResponse,
  FaqListData,
  FaqListError,
  FaqListResponse,
  FaqCreateData,
  FaqCreateError,
  FaqCreateResponse,
  FaqRetrieveData,
  FaqRetrieveError,
  FaqRetrieveResponse,
  FaqUpdateData,
  FaqUpdateError,
  FaqUpdateResponse,
  FaqPartialUpdateData,
  FaqPartialUpdateError,
  FaqPartialUpdateResponse,
  FaqDestroyData,
  FaqDestroyError,
  FaqDestroyResponse,
  GavindustryListData,
  GavindustryListError,
  GavindustryListResponse,
  GavindustryCreateData,
  GavindustryCreateError,
  GavindustryCreateResponse,
  GavindustryRetrieveData,
  GavindustryRetrieveError,
  GavindustryRetrieveResponse,
  GavindustryUpdateData,
  GavindustryUpdateError,
  GavindustryUpdateResponse,
  GavindustryPartialUpdateData,
  GavindustryPartialUpdateError,
  GavindustryPartialUpdateResponse,
  GavindustryDestroyData,
  GavindustryDestroyError,
  GavindustryDestroyResponse,
  IndustryListData,
  IndustryListError,
  IndustryListResponse,
  IndustryCreateData,
  IndustryCreateError,
  IndustryCreateResponse,
  IndustryRetrieveData,
  IndustryRetrieveError,
  IndustryRetrieveResponse,
  IndustryUpdateData,
  IndustryUpdateError,
  IndustryUpdateResponse,
  IndustryPartialUpdateData,
  IndustryPartialUpdateError,
  IndustryPartialUpdateResponse,
  IndustryDestroyData,
  IndustryDestroyError,
  IndustryDestroyResponse,
  IndustryCheckRetrieveData,
  IndustryCheckRetrieveError,
  IndustryCheckRetrieveResponse,
  LohnletterListData,
  LohnletterListError,
  LohnletterListResponse,
  LohnletterCreateData,
  LohnletterCreateError,
  LohnletterCreateResponse,
  LohnletterRetrieveData,
  LohnletterRetrieveError,
  LohnletterRetrieveResponse,
  LohnletterUpdateData,
  LohnletterUpdateError,
  LohnletterUpdateResponse,
  LohnletterPartialUpdateData,
  LohnletterPartialUpdateError,
  LohnletterPartialUpdateResponse,
  LohnletterDestroyData,
  LohnletterDestroyError,
  LohnletterDestroyResponse,
  MunicipalityListData,
  MunicipalityListError,
  MunicipalityListResponse,
  MunicipalityCreateData,
  MunicipalityCreateError,
  MunicipalityCreateResponse,
  MunicipalityRetrieveData,
  MunicipalityRetrieveError,
  MunicipalityRetrieveResponse,
  MunicipalityUpdateData,
  MunicipalityUpdateError,
  MunicipalityUpdateResponse,
  MunicipalityPartialUpdateData,
  MunicipalityPartialUpdateError,
  MunicipalityPartialUpdateResponse,
  MunicipalityDestroyData,
  MunicipalityDestroyError,
  MunicipalityDestroyResponse,
  OccupationListData,
  OccupationListError,
  OccupationListResponse,
  OccupationCreateData,
  OccupationCreateError,
  OccupationCreateResponse,
  OccupationRetrieveData,
  OccupationRetrieveError,
  OccupationRetrieveResponse,
  OccupationUpdateData,
  OccupationUpdateError,
  OccupationUpdateResponse,
  OccupationPartialUpdateData,
  OccupationPartialUpdateError,
  OccupationPartialUpdateResponse,
  OccupationDestroyData,
  OccupationDestroyError,
  OccupationDestroyResponse,
  OccupationalgroupListData,
  OccupationalgroupListError,
  OccupationalgroupListResponse,
  OccupationalgroupCreateData,
  OccupationalgroupCreateError,
  OccupationalgroupCreateResponse,
  OccupationalgroupRetrieveData,
  OccupationalgroupRetrieveError,
  OccupationalgroupRetrieveResponse,
  OccupationalgroupUpdateData,
  OccupationalgroupUpdateError,
  OccupationalgroupUpdateResponse,
  OccupationalgroupPartialUpdateData,
  OccupationalgroupPartialUpdateError,
  OccupationalgroupPartialUpdateResponse,
  OccupationalgroupDestroyData,
  OccupationalgroupDestroyError,
  OccupationalgroupDestroyResponse,
  PageListData,
  PageListError,
  PageListResponse,
  PageCreateData,
  PageCreateError,
  PageCreateResponse,
  PageRetrieveData,
  PageRetrieveError,
  PageRetrieveResponse,
  PageUpdateData,
  PageUpdateError,
  PageUpdateResponse,
  PagePartialUpdateData,
  PagePartialUpdateError,
  PagePartialUpdateResponse,
  PageDestroyData,
  PageDestroyError,
  PageDestroyResponse,
  PositionListData,
  PositionListError,
  PositionListResponse,
  PositionCreateData,
  PositionCreateError,
  PositionCreateResponse,
  PositionRetrieveData,
  PositionRetrieveError,
  PositionRetrieveResponse,
  PositionUpdateData,
  PositionUpdateError,
  PositionUpdateResponse,
  PositionPartialUpdateData,
  PositionPartialUpdateError,
  PositionPartialUpdateResponse,
  PositionDestroyData,
  PositionDestroyError,
  PositionDestroyResponse,
  BerechnungData,
  BerechnungError,
  BerechnungResponse,
  SchemaRetrieveData,
  SchemaRetrieveError,
  SchemaRetrieveResponse,
  TeaserListData,
  TeaserListError,
  TeaserListResponse,
  TeaserCreateData,
  TeaserCreateError,
  TeaserCreateResponse,
  TeaserRetrieveData,
  TeaserRetrieveError,
  TeaserRetrieveResponse,
  TeaserUpdateData,
  TeaserUpdateError,
  TeaserUpdateResponse,
  TeaserPartialUpdateData,
  TeaserPartialUpdateError,
  TeaserPartialUpdateResponse,
  TeaserDestroyData,
  TeaserDestroyError,
  TeaserDestroyResponse
} from './types.gen'

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonList = (options?: Options<CantonListData>) => {
  return (options?.client ?? client).get<CantonListResponse, CantonListError>({
    ...options,
    url: '/api/canton/'
  })
}

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonCreate = (options: Options<CantonCreateData>) => {
  return (options?.client ?? client).post<CantonCreateResponse, CantonCreateError>({
    ...options,
    url: '/api/canton/'
  })
}

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonRetrieve = (options: Options<CantonRetrieveData>) => {
  return (options?.client ?? client).get<CantonRetrieveResponse, CantonRetrieveError>({
    ...options,
    url: '/api/canton/{id}/'
  })
}

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonUpdate = (options: Options<CantonUpdateData>) => {
  return (options?.client ?? client).put<CantonUpdateResponse, CantonUpdateError>({
    ...options,
    url: '/api/canton/{id}/'
  })
}

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonPartialUpdate = (options: Options<CantonPartialUpdateData>) => {
  return (options?.client ?? client).patch<CantonPartialUpdateResponse, CantonPartialUpdateError>({
    ...options,
    url: '/api/canton/{id}/'
  })
}

/**
 * API endpoint that allows cantons to be viewed or edited.
 */
export const cantonDestroy = (options: Options<CantonDestroyData>) => {
  return (options?.client ?? client).delete<CantonDestroyResponse, CantonDestroyError>({
    ...options,
    url: '/api/canton/{id}/'
  })
}

export const categoryList = (options: Options<CategoryListData>) => {
  return (options?.client ?? client).get<CategoryListResponse, CategoryListError>({
    ...options,
    url: '/api/category/'
  })
}

export const categoryCreate = (options: Options<CategoryCreateData>) => {
  return (options?.client ?? client).post<CategoryCreateResponse, CategoryCreateError>({
    ...options,
    url: '/api/category/'
  })
}

export const categoryRetrieve = (options: Options<CategoryRetrieveData>) => {
  return (options?.client ?? client).get<CategoryRetrieveResponse, CategoryRetrieveError>({
    ...options,
    url: '/api/category/{slug}/'
  })
}

export const categoryUpdate = (options: Options<CategoryUpdateData>) => {
  return (options?.client ?? client).put<CategoryUpdateResponse, CategoryUpdateError>({
    ...options,
    url: '/api/category/{slug}/'
  })
}

export const categoryPartialUpdate = (options: Options<CategoryPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    CategoryPartialUpdateResponse,
    CategoryPartialUpdateError
  >({
    ...options,
    url: '/api/category/{slug}/'
  })
}

export const categoryDestroy = (options: Options<CategoryDestroyData>) => {
  return (options?.client ?? client).delete<CategoryDestroyResponse, CategoryDestroyError>({
    ...options,
    url: '/api/category/{slug}/'
  })
}

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationList = (options: Options<EducationListData>) => {
  return (options?.client ?? client).get<EducationListResponse, EducationListError>({
    ...options,
    url: '/api/education/'
  })
}

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationCreate = (options: Options<EducationCreateData>) => {
  return (options?.client ?? client).post<EducationCreateResponse, EducationCreateError>({
    ...options,
    url: '/api/education/'
  })
}

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationRetrieve = (options: Options<EducationRetrieveData>) => {
  return (options?.client ?? client).get<EducationRetrieveResponse, EducationRetrieveError>({
    ...options,
    url: '/api/education/{id}/'
  })
}

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationUpdate = (options: Options<EducationUpdateData>) => {
  return (options?.client ?? client).put<EducationUpdateResponse, EducationUpdateError>({
    ...options,
    url: '/api/education/{id}/'
  })
}

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationPartialUpdate = (options: Options<EducationPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    EducationPartialUpdateResponse,
    EducationPartialUpdateError
  >({
    ...options,
    url: '/api/education/{id}/'
  })
}

/**
 * API endpoint that allows educations to be viewed or edited.
 */
export const educationDestroy = (options: Options<EducationDestroyData>) => {
  return (options?.client ?? client).delete<EducationDestroyResponse, EducationDestroyError>({
    ...options,
    url: '/api/education/{id}/'
  })
}

export const faqList = (options: Options<FaqListData>) => {
  return (options?.client ?? client).get<FaqListResponse, FaqListError>({
    ...options,
    url: '/api/faq/'
  })
}

export const faqCreate = (options: Options<FaqCreateData>) => {
  return (options?.client ?? client).post<FaqCreateResponse, FaqCreateError>({
    ...options,
    url: '/api/faq/'
  })
}

export const faqRetrieve = (options: Options<FaqRetrieveData>) => {
  return (options?.client ?? client).get<FaqRetrieveResponse, FaqRetrieveError>({
    ...options,
    url: '/api/faq/{id}/'
  })
}

export const faqUpdate = (options: Options<FaqUpdateData>) => {
  return (options?.client ?? client).put<FaqUpdateResponse, FaqUpdateError>({
    ...options,
    url: '/api/faq/{id}/'
  })
}

export const faqPartialUpdate = (options: Options<FaqPartialUpdateData>) => {
  return (options?.client ?? client).patch<FaqPartialUpdateResponse, FaqPartialUpdateError>({
    ...options,
    url: '/api/faq/{id}/'
  })
}

export const faqDestroy = (options: Options<FaqDestroyData>) => {
  return (options?.client ?? client).delete<FaqDestroyResponse, FaqDestroyError>({
    ...options,
    url: '/api/faq/{id}/'
  })
}

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryList = (options?: Options<GavindustryListData>) => {
  return (options?.client ?? client).get<GavindustryListResponse, GavindustryListError>({
    ...options,
    url: '/api/gavindustry/'
  })
}

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryCreate = (options: Options<GavindustryCreateData>) => {
  return (options?.client ?? client).post<GavindustryCreateResponse, GavindustryCreateError>({
    ...options,
    url: '/api/gavindustry/'
  })
}

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryRetrieve = (options: Options<GavindustryRetrieveData>) => {
  return (options?.client ?? client).get<GavindustryRetrieveResponse, GavindustryRetrieveError>({
    ...options,
    url: '/api/gavindustry/{id}/'
  })
}

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryUpdate = (options: Options<GavindustryUpdateData>) => {
  return (options?.client ?? client).put<GavindustryUpdateResponse, GavindustryUpdateError>({
    ...options,
    url: '/api/gavindustry/{id}/'
  })
}

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryPartialUpdate = (options: Options<GavindustryPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    GavindustryPartialUpdateResponse,
    GavindustryPartialUpdateError
  >({
    ...options,
    url: '/api/gavindustry/{id}/'
  })
}

/**
 * API endpoint that allows gav industries to be viewed or edited.
 */
export const gavindustryDestroy = (options: Options<GavindustryDestroyData>) => {
  return (options?.client ?? client).delete<GavindustryDestroyResponse, GavindustryDestroyError>({
    ...options,
    url: '/api/gavindustry/{id}/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryList = (options: Options<IndustryListData>) => {
  return (options?.client ?? client).get<IndustryListResponse, IndustryListError>({
    ...options,
    url: '/api/industry/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryCreate = (options: Options<IndustryCreateData>) => {
  return (options?.client ?? client).post<IndustryCreateResponse, IndustryCreateError>({
    ...options,
    url: '/api/industry/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryRetrieve = (options: Options<IndustryRetrieveData>) => {
  return (options?.client ?? client).get<IndustryRetrieveResponse, IndustryRetrieveError>({
    ...options,
    url: '/api/industry/{id}/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryUpdate = (options: Options<IndustryUpdateData>) => {
  return (options?.client ?? client).put<IndustryUpdateResponse, IndustryUpdateError>({
    ...options,
    url: '/api/industry/{id}/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryPartialUpdate = (options: Options<IndustryPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    IndustryPartialUpdateResponse,
    IndustryPartialUpdateError
  >({
    ...options,
    url: '/api/industry/{id}/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryDestroy = (options: Options<IndustryDestroyData>) => {
  return (options?.client ?? client).delete<IndustryDestroyResponse, IndustryDestroyError>({
    ...options,
    url: '/api/industry/{id}/'
  })
}

/**
 * API endpoint that allows industries to be viewed or edited.
 */
export const industryCheckRetrieve = (options: Options<IndustryCheckRetrieveData>) => {
  return (options?.client ?? client).get<IndustryCheckRetrieveResponse, IndustryCheckRetrieveError>(
    {
      ...options,
      url: '/api/industry/{id}/check/'
    }
  )
}

export const lohnletterList = (options: Options<LohnletterListData>) => {
  return (options?.client ?? client).get<LohnletterListResponse, LohnletterListError>({
    ...options,
    url: '/api/lohnletter/'
  })
}

export const lohnletterCreate = (options: Options<LohnletterCreateData>) => {
  return (options?.client ?? client).post<LohnletterCreateResponse, LohnletterCreateError>({
    ...options,
    url: '/api/lohnletter/'
  })
}

export const lohnletterRetrieve = (options: Options<LohnletterRetrieveData>) => {
  return (options?.client ?? client).get<LohnletterRetrieveResponse, LohnletterRetrieveError>({
    ...options,
    url: '/api/lohnletter/{slug}/'
  })
}

export const lohnletterUpdate = (options: Options<LohnletterUpdateData>) => {
  return (options?.client ?? client).put<LohnletterUpdateResponse, LohnletterUpdateError>({
    ...options,
    url: '/api/lohnletter/{slug}/'
  })
}

export const lohnletterPartialUpdate = (options: Options<LohnletterPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    LohnletterPartialUpdateResponse,
    LohnletterPartialUpdateError
  >({
    ...options,
    url: '/api/lohnletter/{slug}/'
  })
}

export const lohnletterDestroy = (options: Options<LohnletterDestroyData>) => {
  return (options?.client ?? client).delete<LohnletterDestroyResponse, LohnletterDestroyError>({
    ...options,
    url: '/api/lohnletter/{slug}/'
  })
}

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityList = (options?: Options<MunicipalityListData>) => {
  return (options?.client ?? client).get<MunicipalityListResponse, MunicipalityListError>({
    ...options,
    url: '/api/municipality/'
  })
}

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityCreate = (options: Options<MunicipalityCreateData>) => {
  return (options?.client ?? client).post<MunicipalityCreateResponse, MunicipalityCreateError>({
    ...options,
    url: '/api/municipality/'
  })
}

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityRetrieve = (options: Options<MunicipalityRetrieveData>) => {
  return (options?.client ?? client).get<MunicipalityRetrieveResponse, MunicipalityRetrieveError>({
    ...options,
    url: '/api/municipality/{id}/'
  })
}

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityUpdate = (options: Options<MunicipalityUpdateData>) => {
  return (options?.client ?? client).put<MunicipalityUpdateResponse, MunicipalityUpdateError>({
    ...options,
    url: '/api/municipality/{id}/'
  })
}

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityPartialUpdate = (options: Options<MunicipalityPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    MunicipalityPartialUpdateResponse,
    MunicipalityPartialUpdateError
  >({
    ...options,
    url: '/api/municipality/{id}/'
  })
}

/**
 * API endpoint that allows municipalities to be viewed or edited.
 */
export const municipalityDestroy = (options: Options<MunicipalityDestroyData>) => {
  return (options?.client ?? client).delete<MunicipalityDestroyResponse, MunicipalityDestroyError>({
    ...options,
    url: '/api/municipality/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationList = (options?: Options<OccupationListData>) => {
  return (options?.client ?? client).get<OccupationListResponse, OccupationListError>({
    ...options,
    url: '/api/occupation/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationCreate = (options: Options<OccupationCreateData>) => {
  return (options?.client ?? client).post<OccupationCreateResponse, OccupationCreateError>({
    ...options,
    url: '/api/occupation/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationRetrieve = (options: Options<OccupationRetrieveData>) => {
  return (options?.client ?? client).get<OccupationRetrieveResponse, OccupationRetrieveError>({
    ...options,
    url: '/api/occupation/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationUpdate = (options: Options<OccupationUpdateData>) => {
  return (options?.client ?? client).put<OccupationUpdateResponse, OccupationUpdateError>({
    ...options,
    url: '/api/occupation/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationPartialUpdate = (options: Options<OccupationPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    OccupationPartialUpdateResponse,
    OccupationPartialUpdateError
  >({
    ...options,
    url: '/api/occupation/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationDestroy = (options: Options<OccupationDestroyData>) => {
  return (options?.client ?? client).delete<OccupationDestroyResponse, OccupationDestroyError>({
    ...options,
    url: '/api/occupation/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupList = (options?: Options<OccupationalgroupListData>) => {
  return (options?.client ?? client).get<OccupationalgroupListResponse, OccupationalgroupListError>(
    {
      ...options,
      url: '/api/occupationalgroup/'
    }
  )
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupCreate = (options: Options<OccupationalgroupCreateData>) => {
  return (options?.client ?? client).post<
    OccupationalgroupCreateResponse,
    OccupationalgroupCreateError
  >({
    ...options,
    url: '/api/occupationalgroup/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupRetrieve = (options: Options<OccupationalgroupRetrieveData>) => {
  return (options?.client ?? client).get<
    OccupationalgroupRetrieveResponse,
    OccupationalgroupRetrieveError
  >({
    ...options,
    url: '/api/occupationalgroup/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupUpdate = (options: Options<OccupationalgroupUpdateData>) => {
  return (options?.client ?? client).put<
    OccupationalgroupUpdateResponse,
    OccupationalgroupUpdateError
  >({
    ...options,
    url: '/api/occupationalgroup/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupPartialUpdate = (
  options: Options<OccupationalgroupPartialUpdateData>
) => {
  return (options?.client ?? client).patch<
    OccupationalgroupPartialUpdateResponse,
    OccupationalgroupPartialUpdateError
  >({
    ...options,
    url: '/api/occupationalgroup/{id}/'
  })
}

/**
 * API endpoint that allows occupations to be viewed or edited.
 */
export const occupationalgroupDestroy = (options: Options<OccupationalgroupDestroyData>) => {
  return (options?.client ?? client).delete<
    OccupationalgroupDestroyResponse,
    OccupationalgroupDestroyError
  >({
    ...options,
    url: '/api/occupationalgroup/{id}/'
  })
}

export const pageList = (options: Options<PageListData>) => {
  return (options?.client ?? client).get<PageListResponse, PageListError>({
    ...options,
    url: '/api/page/'
  })
}

export const pageCreate = (options: Options<PageCreateData>) => {
  return (options?.client ?? client).post<PageCreateResponse, PageCreateError>({
    ...options,
    url: '/api/page/'
  })
}

export const pageRetrieve = (options: Options<PageRetrieveData>) => {
  return (options?.client ?? client).get<PageRetrieveResponse, PageRetrieveError>({
    ...options,
    url: '/api/page/{slug}/'
  })
}

export const pageUpdate = (options: Options<PageUpdateData>) => {
  return (options?.client ?? client).put<PageUpdateResponse, PageUpdateError>({
    ...options,
    url: '/api/page/{slug}/'
  })
}

export const pagePartialUpdate = (options: Options<PagePartialUpdateData>) => {
  return (options?.client ?? client).patch<PagePartialUpdateResponse, PagePartialUpdateError>({
    ...options,
    url: '/api/page/{slug}/'
  })
}

export const pageDestroy = (options: Options<PageDestroyData>) => {
  return (options?.client ?? client).delete<PageDestroyResponse, PageDestroyError>({
    ...options,
    url: '/api/page/{slug}/'
  })
}

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionList = (options: Options<PositionListData>) => {
  return (options?.client ?? client).get<PositionListResponse, PositionListError>({
    ...options,
    url: '/api/position/'
  })
}

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionCreate = (options: Options<PositionCreateData>) => {
  return (options?.client ?? client).post<PositionCreateResponse, PositionCreateError>({
    ...options,
    url: '/api/position/'
  })
}

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionRetrieve = (options: Options<PositionRetrieveData>) => {
  return (options?.client ?? client).get<PositionRetrieveResponse, PositionRetrieveError>({
    ...options,
    url: '/api/position/{id}/'
  })
}

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionUpdate = (options: Options<PositionUpdateData>) => {
  return (options?.client ?? client).put<PositionUpdateResponse, PositionUpdateError>({
    ...options,
    url: '/api/position/{id}/'
  })
}

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionPartialUpdate = (options: Options<PositionPartialUpdateData>) => {
  return (options?.client ?? client).patch<
    PositionPartialUpdateResponse,
    PositionPartialUpdateError
  >({
    ...options,
    url: '/api/position/{id}/'
  })
}

/**
 * API endpoint that allows positions to be viewed or edited.
 */
export const positionDestroy = (options: Options<PositionDestroyData>) => {
  return (options?.client ?? client).delete<PositionDestroyResponse, PositionDestroyError>({
    ...options,
    url: '/api/position/{id}/'
  })
}

export const berechnung = (options: Options<BerechnungData>) => {
  return (options?.client ?? client).post<BerechnungResponse, BerechnungError>({
    ...options,
    url: '/api/rechner/berechnung/'
  })
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieve = (options?: Options<SchemaRetrieveData>) => {
  return (options?.client ?? client).get<SchemaRetrieveResponse, SchemaRetrieveError>({
    ...options,
    url: '/api/schema/'
  })
}

export const teaserList = (options: Options<TeaserListData>) => {
  return (options?.client ?? client).get<TeaserListResponse, TeaserListError>({
    ...options,
    url: '/api/teaser/'
  })
}

export const teaserCreate = (options: Options<TeaserCreateData>) => {
  return (options?.client ?? client).post<TeaserCreateResponse, TeaserCreateError>({
    ...options,
    url: '/api/teaser/'
  })
}

export const teaserRetrieve = (options: Options<TeaserRetrieveData>) => {
  return (options?.client ?? client).get<TeaserRetrieveResponse, TeaserRetrieveError>({
    ...options,
    url: '/api/teaser/{id}/'
  })
}

export const teaserUpdate = (options: Options<TeaserUpdateData>) => {
  return (options?.client ?? client).put<TeaserUpdateResponse, TeaserUpdateError>({
    ...options,
    url: '/api/teaser/{id}/'
  })
}

export const teaserPartialUpdate = (options: Options<TeaserPartialUpdateData>) => {
  return (options?.client ?? client).patch<TeaserPartialUpdateResponse, TeaserPartialUpdateError>({
    ...options,
    url: '/api/teaser/{id}/'
  })
}

export const teaserDestroy = (options: Options<TeaserDestroyData>) => {
  return (options?.client ?? client).delete<TeaserDestroyResponse, TeaserDestroyError>({
    ...options,
    url: '/api/teaser/{id}/'
  })
}
